import CryptoJS from "crypto-js";

const PASSPHRASE = "BGCM_KEY_PRKABAVINA!DEVIJVIKPA";

export function getDecryptedToken(encryptedToken) {
  //console.log("etoken:"+encryptedToken)
  const bytes = CryptoJS.AES.decrypt(encryptedToken, PASSPHRASE);
  return bytes.toString(CryptoJS.enc.Utf8);
}
